/* iBrushy solution 8 kit guard (ibrushy-tracking, 2026-10). Sole definer of window.ibOffers.
   GENERATED: dist/ib2-kit-guard.js = guard.src.js + the registry built from bundles-2026-10/kit_table.py (switch-2026-10/guard/build.py).
   Loads defer after assets/ib-cart.js. Every repair goes through the frozen executor window.ibCart.runCream (FIFO transaction),
   serialized across tabs with navigator.locks. The cart is the only state: the plan is recomputed from a fresh cart.js each pass.
   Rules: a pack added through window.ibCart.add or a JSON fetch add leaves as its kit rows (12/10; pair packs paired with their add-on, 13/10); old pack variants -> kit rows (one _kit group per pack unit); a kit missing a paid row or holding a foreign row leaves
   whole (5 s undo); a kit row above its quantity is reset and the extra pieces are added at the regular price; hidden rows outside
   a kit are removed (Pieno rows may stand alone); a bar (regular or x2/x4 pack) bought with its add-on becomes a paired kit;
   cream quantity breaks get gift rows (no glove offer since 12/10); a regular single (face, serum, cream, leopard, mini face,
   paid bag) leaves as its hidden Singola row, same price, in the request and in the cart (13/10); gift bags follow the bag rule v2 minus the bags already packed in the line SKUs and
   are hidden in the cart (_instant-hidden). Lines carrying __kaching_bundles
   (MAIN carts) are read-only. */
(() => {
  'use strict';
  if (window.ibOffers) return;
  const REG = {"kits":{"corpo-viso-starter":[[56970611425666,"pagato",1],[56970611753346,"regalo",1]],"glowy":[[56970612539778,"pagato",1],[56970611458434,"pagato",1],[56970613522818,"regalo",1]],"glowy-crema-oceano":[[56970612703618,"pagato",1],[56970611458434,"pagato",1],[56970613522818,"regalo",1]],"dream-skin":[[56970612113794,"pagato",1],[56970611720578,"pagato",1],[56970611491202,"pagato",1],[56970612572546,"regalo",1],[56970613522818,"regalo",1]],"viso-x1":[[56970611655042,"pagato",1]],"viso-x2-1-leopard":[[56970611655042,"pagato",1],[56970600513922,"pagato",1]],"viso-x4-2-2-free":[[56970611655042,"pagato",1],[56970611687810,"pagato",1],[56970600579458,"regalo",2]],"viso-x2-siero":[[56970611655042,"pagato",1],[56970600513922,"pagato",1],[56970612146562,"pagato",1]],"siero-x1":[[56970611982722,"pagato",1]],"siero-x2":[[56970611982722,"pagato",1],[56970612015490,"pagato",1]],"siero-x4":[[56970611982722,"pagato",1],[56970612048258,"pagato",1],[56970612081026,"regalo",2]],"crema-x1":[[56970612507010,"pagato",1]],"crema-2-1":[[56970612507010,"pagato",2],[56970612572546,"regalo",1]],"viso-siero-aggiunto-europa-uk-us":[[56970611655042,"pagato",1],[56970612179330,"pagato",1]],"viso-siero-aggiunto-italia":[[56970611655042,"pagato",1],[56970611982722,"pagato",1]],"guanto-x1":[[56970613490050,"pagato",1]],"siero-leopard-aggiunta":[[56970611982722,"pagato",1],[56970600546690,"pagato",1]],"siero-x2-leopard-aggiunta":[[56970611982722,"pagato",1],[56970612015490,"pagato",1],[56970600546690,"pagato",1]],"siero-x4-leopard-aggiunta":[[56970611982722,"pagato",1],[56970612048258,"pagato",1],[56970612081026,"regalo",2],[56970600546690,"pagato",1]],"viso-x2-siero-aggiunto-europa-uk-us":[[56970611655042,"pagato",1],[56970600513922,"pagato",1],[56970612179330,"pagato",1]],"viso-x4-siero-aggiunto-europa-uk-us":[[56970611655042,"pagato",1],[56970611687810,"pagato",1],[56970600579458,"regalo",2],[56970612179330,"pagato",1]]},"market":{"viso-siero-aggiunto-europa-uk-us":"other","viso-siero-aggiunto-italia":"it","viso-x2-siero-aggiunto-europa-uk-us":"other","viso-x4-siero-aggiunto-europa-uk-us":"other"},"pack":{"56357276057986":"viso-x2-1-leopard","56357276090754":"viso-x4-2-2-free","56357276123522":"viso-x2-siero","56357176476034":"siero-x2","56357176508802":"siero-x4","55898914587010":"corpo-viso-starter","55893121433986":"glowy","55893121499522":"dream-skin"},"ocean":{"56970612507010":56970612670850,"56970612539778":56970612703618,"56970612572546":56970612736386},"glowyOcean":"glowy-crema-oceano","pairs":[{"a":56357276057986,"b":56360092238210,"kit":"viso-x2-siero-aggiunto-europa-uk-us","notIT":true},{"a":56357276090754,"b":56360092238210,"kit":"viso-x4-siero-aggiunto-europa-uk-us","notIT":true},{"a":56360005403010,"b":56360092238210,"kit":"viso-siero-aggiunto-europa-uk-us","notIT":true},{"a":56357176476034,"b":56353879032194,"kit":"siero-x2-leopard-aggiunta","notIT":false},{"a":56357176508802,"b":56353879032194,"kit":"siero-x4-leopard-aggiunta","notIT":false},{"a":56360092238210,"b":56353879032194,"kit":"siero-leopard-aggiunta","notIT":false}],"breaks":{"crema":{"ids":[55484501033346,55484501066114],"gift":56970612572546,"giftOcean":56970612736386,"it":[[2,1]],"other":[[2,1]]}},"regular":{"56970611655042":56360005403010,"56970611687810":56360005403010,"56970611720578":56360005403010,"56970611753346":56360005403010,"56970600481154":56353879032194,"56970600513922":56353879032194,"56970600546690":56353879032194,"56970600579458":56353879032194,"56970611982722":56360092238210,"56970612015490":56360092238210,"56970612048258":56360092238210,"56970612081026":56360092238210,"56970612113794":56360092238210,"56970612146562":56360092238210,"56970612179330":56360092238210,"56970612507010":55484501033346,"56970612539778":55484501033346,"56970612572546":55484501033346,"56970612670850":55484501066114,"56970612703618":55484501066114,"56970612736386":55484501066114,"56970613490050":null,"56970613522818":null,"56970611425666":56970611425666,"56970611458434":56970611425666,"56970611491202":56970611425666,"56972998377858":null,"56976572514690":55132555018626,"56976572744066":56362042327426},"standalone":[56970611425666,56970611655042,56970600481154,56970611982722,56970612507010,56970612670850,56970613490050,56976572514690,56976572744066],"bags":{"small":56970613981570,"big":56970614243714},"express":56970614440322,"units":{"56970611425666":[1,0],"56970611458434":[1,0],"56970611491202":[1,0],"56970611655042":[1,0],"56970611687810":[1,0],"56970611720578":[1,0],"56970611753346":[1,0],"56970600481154":[1,0],"56970600513922":[1,0],"56970600546690":[1,0],"56970600579458":[1,0],"56970611982722":[0,1],"56970612015490":[0,1],"56970612048258":[0,1],"56970612081026":[0,1],"56970612113794":[0,1],"56970612146562":[0,1],"56970612179330":[0,1],"56970612507010":[0,1],"56970612539778":[0,1],"56970612572546":[0,1],"56970612670850":[0,1],"56970612703618":[0,1],"56970612736386":[0,1],"56970613490050":[0,1],"56970613522818":[0,1],"56972998377858":[0,1],"56360005403010":[1,0],"56353879032194":[1,0],"55132555018626":[1,0],"56976572514690":[1,0],"56360092238210":[0,1],"55484501033346":[0,1],"55484501066114":[0,1],"55132555051394":[0,1],"56360201224578":[0,1],"56357441601922":[0,2],"56357441634690":[0,3],"56357276057986":[2,0],"56357276090754":[4,0],"56357276123522":[2,1],"56357176476034":[0,2],"56357176508802":[0,4],"55898914587010":[2,0],"55893121433986":[1,2],"55893121499522":[2,3]},"included":{"56360005403010":[1,0],"56360092238210":[0,1],"55484501033346":[0,1],"55484501066114":[0,1],"56360201224578":[0,1],"56357441601922":[0,1],"56357441634690":[0,1],"56357276057986":[1,0],"56357276090754":[2,0],"56357276123522":[1,1],"56357176476034":[0,1],"56357176508802":[0,2],"55898914587010":[1,0],"55893121433986":[1,1],"55893121499522":[1,1]}};
  for (const k of ['kits', 'pack', 'ocean', 'regular', 'units', 'market', 'breaks', 'included']) REG[k] = Object.assign(Object.create(null), REG[k]); // '_kit: constructor~x' must not hit Object.prototype
  const COPY = { // copywriter 08/10 + case 12/10 (Simone #14), guard/COPY-TOAST.md
    it: { removed: 'Offerta rimossa per intero', undo: 'Rimettila', failed: "Non siamo riusciti a rimettere l'offerta. Riprova", extra: "L'offerta resta com'è. Il pezzo in più è a prezzo singolo" },
    en: { removed: 'Whole offer removed', undo: 'Undo', failed: "We couldn't add your offer back. Try again", extra: 'Your offer stays as is. Extras are at the single-item price' }
  };
  const BAG = { _ruolo: 'bag', '_instant-hidden': 'true' };
  const S = (id) => String(id);
  const props = (l) => l.properties || {};
  const pk = (p) => JSON.stringify(Object.keys(p || {}).sort().map((k) => [k, p[k]])); // props identity, key order free
  const ocean = new Set(Object.values(REG.ocean).map(S));
  const hidden = new Set([...Object.keys(REG.regular), S(REG.bags.small), S(REG.bags.big), S(REG.express)]);
  const standalone = new Set(REG.standalone.map(S));
  const gid = () => Math.random().toString(36).slice(2, 8);
  const sameId = (lineId, rowId) => S(lineId) === S(rowId) || S(lineId) === S(REG.ocean[S(rowId)]);
  // fragrance select of the body widget (snippets/ib-offer-body.liquid): {Crema: 'Ocean'} on IT, {Cream: 'Ocean'} on EN markets
  const wantsOcean = (l) => /^ocean/i.test(String(props(l).Crema || props(l).Cream || ''));
  const freeId = (id, p) => !p._kit && (!hidden.has(S(id)) || standalone.has(S(id))); // a regular line, not in any kit
  const canonId = (id) => (standalone.has(S(id)) ? S(REG.regular[S(id)] || id) : S(id));
  // Simone 13/10 «Copia nascosta»: regular single -> its hidden Singola row (same price everywhere, the packshot as its image)
  const single = Object.create(null);
  for (const s of REG.standalone) { const r = REG.regular[S(s)]; if (r && S(r) !== S(s)) single[S(r)] = s; }
  const asSingle = (id) => single[S(id)] || id;

  // the rows of one kit unit, ready for add.js
  function kitRows(kit, withOcean) {
    const key = withOcean && kit === REG.pack['55893121433986'] ? REG.glowyOcean : kit;
    const g = key + '~' + gid();
    return REG.kits[key].map(([id, role, q]) => ({
      id: withOcean && REG.ocean[S(id)] ? REG.ocean[S(id)] : id, quantity: q, properties: { _kit: g, _ruolo: role }
    }));
  }

  // Pure planner: cart.js JSON -> {ops, receipts, extra}. Recomputed from scratch on every pass (idempotent on a valid cart).
  function plan(cart, market) { // market: 'it' | 'other' | '' (unknown: no add-on discount, stricter breaks)
    const it = market === 'it';
    const lines = (cart && cart.items) || [];
    const qty = new Map(lines.map((l) => [l.key, l.quantity])); // final quantity per line key
    const adds = [];
    const receipts = [];
    let extra = false;
    const set = (l, q) => qty.set(l.key, q);
    const live = lines.filter((l) => !props(l).__kaching_bundles || hidden.has(S(l.variant_id))); // Kaching never adds hidden variants: on them the prop is forged
    const free = (l) => freeId(l.variant_id, props(l));
    const canon = (l) => canonId(l.variant_id);

    // A. kit groups
    const groups = new Map();
    for (const l of live) {
      const k = props(l)._kit;
      if (!k || k.indexOf('~') <= 0) continue;
      // no kit holds an express row since 12/10 (build.py asserts it): an older cart's €0 express row goes alone, the kit stays
      if (S(l.variant_id) === S(REG.express)) set(l, 0);
      else (groups.get(k) || groups.set(k, []).get(k)).push(l);
    }
    for (const [g, gl] of groups) {
      const kit = g.split('~')[0];
      const comp = REG.kits[kit];
      const seen = new Map((comp || []).map((r, i) => [i, []]));
      if (comp && REG.market[kit] && REG.market[kit] !== market) { // a market-only kit outside its market: products stay, full price
        gl.forEach((l) => {
          set(l, 0);
          const reg = props(l)._ruolo === 'pagato' && REG.regular[S(l.variant_id)];
          if (reg) adds.push({ id: asSingle(reg), quantity: l.quantity });
        });
        continue;
      }
      let broken = !comp, short = false;
      for (const l of gl) {
        const i = comp ? comp.findIndex((r) => sameId(l.variant_id, r[0])) : -1;
        if (i < 0) broken = true; else seen.get(i).push(l);
      }
      if (comp) comp.forEach(([, role, q], i) => {
        if (role === 'pagato' && seen.get(i).reduce((s, l) => s + l.quantity, 0) < q) broken = short = true;
      });
      if (broken) {
        gl.forEach((l) => set(l, 0));
        if (short && comp) receipts.push({ kit, ocean: gl.some((l) => ocean.has(S(l.variant_id))) });
        continue;
      }
      comp.forEach(([, , q], i) => {
        const ls = seen.get(i);
        const n = ls.reduce((s, l) => s + l.quantity, 0);
        if (n <= q) return;
        let room = q; // the kit keeps q across its rows, the rest becomes regular pieces
        ls.forEach((l) => { const k = Math.min(room, l.quantity); set(l, k); room -= k; });
        const rest = n - q;
        const reg = REG.regular[S(ls[0].variant_id)];
        if (reg && rest > 0) { adds.push({ id: asSingle(reg), quantity: rest }); extra = true; }
      });
    }

    // B. hidden rows outside a kit (bags and break gifts are handled below)
    const bagIds = new Set([S(REG.bags.small), S(REG.bags.big)]);
    for (const l of live) {
      const k = props(l)._kit || '';
      if (!hidden.has(S(l.variant_id)) || bagIds.has(S(l.variant_id)) || k.indexOf('~') > 0 || (k.indexOf('q:') === 0 && REG.breaks[k.slice(2)])) continue;
      if (!(standalone.has(S(l.variant_id)) && !k)) set(l, 0);
    }

    // C. bar + add-on lines bought together -> paired kit (serum add-on on the face bars outside Italy, leopard add-on on the
    // serum bars). A bar is a regular line or an x2/x4 pack line; pairs run before the packs convert alone.
    for (const p of REG.pairs) {
      if (p.notIT && market !== 'other') continue;
      const pick = (id) => live.filter((l) => free(l) && canon(l) === S(id) && qty.get(l.key) > 0);
      const A = pick(p.a), B = pick(p.b);
      let n = Math.min(A.reduce((s, l) => s + qty.get(l.key), 0), B.reduce((s, l) => s + qty.get(l.key), 0));
      const take = (ls, m) => { for (const l of ls) { const t = Math.min(m, qty.get(l.key)); set(l, qty.get(l.key) - t); m -= t; } };
      take(A, n); take(B, n);
      for (; n > 0; n -= 1) adds.push(...kitRows(p.kit, false));
    }

    // D. the remaining old pack variants -> kits
    for (const l of live) {
      const kit = REG.pack[S(l.variant_id)];
      if (!kit) continue;
      for (let i = 0; i < qty.get(l.key); i += 1) adds.push(...kitRows(kit, wantsOcean(l)));
      set(l, 0);
    }

    // E. quantity breaks: gift rows follow the regular quantity
    for (const [name, b] of Object.entries(REG.breaks)) {
      const paid = live.filter((l) => free(l) && b.ids.some((id) => S(id) === canon(l)));
      const n = paid.reduce((s, l) => s + qty.get(l.key), 0);
      const want = (it ? b.it : b.other).reduce((g, [min, gifts]) => (n >= min ? gifts : g), 0);
      const oc = b.giftOcean && paid.filter((l) => canon(l) === S(b.ids[1])).reduce((s, l) => s + qty.get(l.key), 0) * 2 > n;
      const giftId = oc ? b.giftOcean : b.gift;
      const have = live.filter((l) => props(l)._kit === 'q:' + name);
      const keep = have.find((l) => S(l.variant_id) === S(giftId));
      have.forEach((l) => l !== keep && set(l, 0));
      if (keep) set(keep, want);
      else if (want) adds.push({ id: giftId, quantity: want, properties: { _kit: 'q:' + name, _ruolo: 'regalo' } });
    }

    // E2. a regular single still free -> its Singola row, same quantity and properties (the net for adds that bypass
    // window.ibCart / JSON fetch, and old carts); the bag its regular SKU packed comes from F as a gift bag row
    for (const l of live) {
      const s = free(l) && single[S(l.variant_id)];
      if (!s || !(qty.get(l.key) > 0)) continue;
      adds.push({ id: s, quantity: qty.get(l.key), properties: props(l) });
      set(l, 0);
    }

    // F. gift bags on the final cart (bag rule v2: 1 small per 2 brushes; 1 big with serum/cream/oil/glove, 2 from 8 products).
    // Bags shipped = bags already packed in the SKU of a line (REG.included) + bag rows; the guard adds only what is missing.
    let brush = 0, other = 0, inSmall = 0, inBig = 0;
    const count = (id, q) => {
      const u = REG.units[S(id)], b = REG.included[S(id)];
      if (u) { brush += u[0] * q; other += u[1] * q; }
      if (b) { inSmall += b[0] * q; inBig += b[1] * q; }
    };
    lines.forEach((l) => count(l.variant_id, qty.get(l.key)));
    adds.forEach((a) => count(a.id, a.quantity));
    const want = { [S(REG.bags.small)]: Math.max(0, Math.ceil(brush / 2) - inSmall),
      [S(REG.bags.big)]: Math.max(0, (other ? (brush + other >= 8 ? 2 : 1) : 0) - inBig) };
    for (const id of Object.keys(want)) {
      const have = live.filter((l) => S(l.variant_id) === id);
      const keep = have.find((l) => props(l)._ruolo === 'bag' && props(l)['_instant-hidden'] === 'true');
      have.forEach((l) => l !== keep && set(l, 0));
      if (keep) set(keep, want[id]);
      else if (want[id]) adds.push({ id: Number(id), quantity: want[id], properties: BAG });
    }

    const items = [];
    for (const a of adds) {
      const same = lines.find((l) => S(l.variant_id) === S(a.id) && pk(props(l)) === pk(a.properties));
      const prev = same || items.find((x) => S(x.id) === S(a.id) && pk(x.properties) === pk(a.properties));
      if (same) set(same, qty.get(same.key) + a.quantity);
      else if (prev) prev.quantity += a.quantity;
      else items.push({ ...a });
    }
    const updates = {};
    for (const l of lines) if (qty.get(l.key) !== l.quantity) updates[l.key] = qty.get(l.key);
    const ops = [];
    if (items.length) ops.push({ op: 'add', input: { items } }); // new lines first: existing line keys do not change
    if (Object.keys(updates).length) ops.push({ op: 'update_lines', input: { updates } });
    return { ops, receipts, extra };
  }

  const market = () => { const c = String((window.Shopify && window.Shopify.country) || '').toUpperCase(); return c === 'IT' ? 'it' : c ? 'other' : ''; };
  const lang = () => (/^it/i.test(document.documentElement.lang || '') ? COPY.it : COPY.en);
  let last = { ops: [], receipts: [], extra: false };
  const pending = { receipts: [], extra: false };

  // read by the frozen executor (ib-cart.js runCream) on every reconcile pass
  let crashed = false;
  // last plan with add + update: if only the add landed, resend just the update instead of converting the source again
  let prev = null;
  const sum = (ls) => ls.reduce((s, l) => s + l.quantity, 0);
  function planReconcile(cart) {
    try {
      const items = (cart && cart.items) || [];
      const q = new Map(items.map((l) => [l.key, l.quantity]));
      // match only the cart this exact add produced: its new rows (random kit ids) present at their exact quantity
      const landed = (a) => items.some((l) => S(l.variant_id) === S(a.id) && pk(props(l)) === pk(a.properties) && l.quantity === a.quantity);
      if (prev && sum(items) === prev.count + prev.added && Object.keys(prev.old).every((k) => q.get(k) === prev.old[k]) && prev.items.every(landed)) {
        last = { ops: [{ op: 'update_lines', input: { updates: prev.updates } }], receipts: [], extra: false };
      } else {
        last = plan(cart, market());
        const a = last.ops.find((o) => o.op === 'add'), u = last.ops.find((o) => o.op === 'update_lines');
        prev = a && u ? { count: sum(items), added: sum(a.input.items), items: a.input.items, updates: u.input.updates,
          old: Object.fromEntries(Object.keys(u.input.updates).map((k) => [k, q.get(k)])) } : null;
      }
    } catch (e) { crashed = true; prev = null; last = { ops: [], receipts: [], extra: false }; }
    pending.receipts.push(...last.receipts);
    pending.extra = pending.extra || last.extra;
    return last.ops;
  }

  // ---------- coordinator ----------
  let running = null, again = false, inTx = false;
  const lock = (fn) => (navigator.locks ? navigator.locks.request('ib2-kit-guard', fn) : fn());
  function run() {
    if (running) { again = true; return running; }
    running = (async () => {
      let clean = false;
      for (let i = 0; i < 3 && !clean; i += 1) { // ponytail: bounded repair budget (3 passes), then checkout stays locked
        again = false;
        crashed = false;
        inTx = true;
        const r = await lock(() => window.ibCart.runCream([])).catch(() => null).finally(() => { inTx = false; });
        clean = r && r.ok && !last.ops.length && !again && !crashed;
      }
      document.querySelectorAll('[data-ib-checkout]').forEach((el) => {
        if (clean) el.removeAttribute('aria-disabled'); else el.setAttribute('aria-disabled', 'true');
      });
      if (!clean) document.querySelectorAll('[data-ib-cart-zone="error"]').forEach((z) => { z.hidden = false; });
    })().finally(() => { running = null; flush(); });
    return running;
  }

  function addKit(r) {
    if (!r || !REG.kits[r.kit]) return Promise.reject(new Error('unknown kit'));
    return window.ibCart.add({ items: kitRows(r.kit, r.ocean) }).then(run);
  }

  // ---------- pack add -> kit rows (Simone 12/10 body packs, 13/10 «Sì, estendi» pair packs: the pack never shows in the cart) ----------
  // The offers add their pack through window.ibCart.add (assets/ib2-product.js) or fetch (assets/ib-pdp.js, the Instant PDPs), JSON
  // {items}: the kit rows steps C and D would make go in that same request instead. A pair pack (face/serum x2, x4, where its pair applies) needs the cart first (GET in the same
  // queue slot): with no free add-on line there, it takes its add-on from this request in step C order (paired kit, the add-on
  // item shrinks) and a unit left over converts alone (step D). A free add-on line already in the cart is step C's to pair, as
  // before (an add cannot lower another line): the left-over units go as is; and if that line is one the request's add-on would
  // not merge into (a hidden Pieno, other properties), step C picks between the two by cart order, so the whole pack goes as is.
  // Cart unknown (read failed): pair packs go as is. Kaching lines and odd quantities are left alone. Step D stays the net for
  // old carts, permalinks and adds that bypass window.ibCart.
  const pairOf = Object.create(null); // pack variant -> its pair (pairs with a regular bar are step C's job)
  for (const p of REG.pairs) if (REG.pack[S(p.a)]) pairOf[S(p.a)] = p;
  const n = (it) => Number(it.quantity == null ? 1 : it.quantity);
  const ok = (it) => !props(it).__kaching_bundles && Number.isInteger(n(it)) && n(it) > 0;
  // 13/10: a regular single item leaves as its Singola row (step E2 in the request), before the pack logic sees it
  const toSingle = (it) => (it && ok(it) && !props(it)._kit && single[S(it.id)] ? { ...it, id: single[S(it.id)] } : it);
  function toKits(items, m) {
    const on = (p) => !(p.notIT && m !== 'other');
    const addon = (it) => ok(it) && pairOf[S(it.id)] && on(pairOf[S(it.id)]) && S(pairOf[S(it.id)].b); // its pair applies here
    const wait = items.some(addon);
    const build = (cart) => { // cart.js JSON of this moment; null = unknown
      const live = cart && (cart.items || []).filter((l) => l.quantity > 0 && (!props(l).__kaching_bundles || hidden.has(S(l.variant_id)))
        && freeId(l.variant_id, props(l))); // free lines, as step C sees them
      const has = (b) => !live || live.some((l) => canonId(l.variant_id) === b);
      const clash = (b) => !live || live.some((l) => canonId(l.variant_id) === b
        && !items.some((it) => S(it.id) === S(l.variant_id) && pk(props(it)) === pk(props(l))));
      const left = items.map((it) => (ok(it) && REG.pack[S(it.id)] ? n(it) : 0)); // pack units still to convert
      const give = items.map((it) => (ok(it) && freeId(it.id, props(it)) ? n(it) : 0)); // units an add-on item can give
      const spare = [...give];
      const paired = items.map(() => []);
      for (const p of REG.pairs) {
        if (!on(p) || clash(S(p.b))) continue;
        items.forEach((a, i) => {
          if (S(a.id) !== S(p.a) || !left[i]) return;
          items.forEach((b, j) => {
            if (canonId(b.id) !== S(p.b)) return;
            for (; left[i] && spare[j]; left[i] -= 1, spare[j] -= 1) paired[i].push(...kitRows(p.kit, false));
          });
        });
      }
      return items.flatMap((it, i) => {
        if (left[i] || paired[i].length) {
          const rest = !left[i] ? [] : addon(it) && has(addon(it)) ? [left[i] === n(it) ? it : { ...it, quantity: left[i] }]
            : Array.from({ length: left[i] }, () => kitRows(REG.pack[S(it.id)], wantsOcean(it))).flat();
          return [...paired[i], ...rest];
        }
        return spare[i] === give[i] ? [it] : spare[i] ? [{ ...it, quantity: spare[i] }] : [];
      });
    };
    return { wait, build };
  }
  // Serialize every JSON items add with the cart queue. Reads share that slot when pair logic or bag planning needs the current cart.
  let localAddBusy = false;
  const localAdds = [];
  function drainLocalAdds() {
    if (localAddBusy || !localAdds.length) return;
    localAddBusy = true;
    const job = localAdds.shift();
    let result;
    try { result = job.fn(); } catch (e) { job.reject(e); localAddBusy = false; drainLocalAdds(); return; }
    Promise.resolve(result).then(job.resolve, job.reject).finally(() => { localAddBusy = false; drainLocalAdds(); });
  }
  function localAddSlot(fn) {
    return new Promise((resolve, reject) => {
      localAdds.push({ fn, resolve, reject });
      drainLocalAdds();
    });
  }
  function withAddQueue(fn) {
    const api = window.ibCart;
    if (api && typeof api.transaction === 'function') return api.transaction(fn);
    return localAddSlot(() => fn(null));
  }
  function addGiftBags(cart, items) {
    const proposed = (cart.items || []).slice();
    const preview = gid();
    items.forEach((it, i) => proposed.push({ key: '__ib2_pending_' + preview + '_' + i, variant_id: it.id,
      quantity: n(it), properties: props(it) }));
    const giftIds = new Set([S(REG.bags.small), S(REG.bags.big)]);
    const gifts = [];
    for (const op of plan({ items: proposed }, market()).ops) {
      if (op.op !== 'add') continue;
      for (const a of op.input.items || []) {
        const p = props(a);
        if (giftIds.has(S(a.id)) && p._ruolo === 'bag' && p['_instant-hidden'] === 'true') gifts.push(a);
      }
    }
    return gifts.length ? items.concat(gifts.map((a) => ({ ...a, properties: { ...props(a) } }))) : items;
  }
  // null = no cart API/read available; pair packs and gift bags keep post-add reconciliation as their fallback.
  function viaKits(raw, send) {
    if (!Array.isArray(raw)) return null;
    let items = raw, k;
    try {
      items = raw.map(toSingle);
      k = items.some((it) => it && REG.pack[S(it.id)]) ? toKits(items, market()) : { wait: false, build: () => items };
    } catch (e) {
      items = raw;
      k = { wait: false, build: () => items };
    }
    const affectsBags = items.some((it) => {
      if (!ok(it)) return false;
      const u = REG.units[S(it.id)], b = REG.included[S(it.id)];
      return !!((u && (u[0] || u[1])) || (b && (b[0] || b[1])));
    });
    const needsCart = k.wait || affectsBags;
    const next = (cart) => {
      let built;
      try { built = k.build(cart); } catch (e) { built = items; }
      if (cart && affectsBags) {
        try { built = addGiftBags(cart, built); } catch (e) { /* post-add reconciliation remains the fallback */ }
      }
      return built;
    };
    return withAddQueue((tx) => {
      const deliver = (cart) => send(next(cart), tx);
      if (!needsCart || !tx || typeof tx.get !== 'function') return deliver(null);
      return tx.get().then((r) => deliver(r && r.data || null), () => deliver(null));
    });
  }
  if (window.ibCart && typeof window.ibCart.add === 'function') {
    const add = window.ibCart.add;
    window.ibCart.add = (input) => (input && viaKits(input.items, (items, tx) => (tx ? tx.send({ op: 'add', input: { ...input, items } })
      : add({ ...input, items })))) || add(input);
  }

  // ---------- toast ----------
  let toast = null, timer = 0;
  function show(text, receipt) {
    if (!toast) {
      toast = document.createElement('div');
      toast.setAttribute('role', 'status');
      toast.style.cssText = 'position:fixed;left:50%;bottom:16px;transform:translateX(-50%);z-index:2147483000;display:flex;gap:12px;width:max-content;' // left:50% alone caps the box at half the viewport (195 px at 390): Undo broke mid-word
        + 'align-items:center;max-width:calc(100% - 32px);padding:12px 16px;border-radius:8px;background:#111;color:#fff;font:14px/1.3 inherit;'
        + 'box-shadow:0 4px 16px rgba(0,0,0,.25)';
      document.body.append(toast);
    }
    clearTimeout(timer);
    const span = document.createElement('span');
    span.textContent = text;
    toast.replaceChildren(span);
    toast.style.display = 'flex'; // inline display beats the hidden attribute, so toggle display itself
    if (receipt) {
      const b = document.createElement('button');
      b.type = 'button';
      b.textContent = lang().undo;
      b.style.cssText = 'background:none;border:0;color:inherit;font:inherit;font-weight:700;text-decoration:underline;cursor:pointer;padding:0;white-space:nowrap;flex:none;text-transform:none;letter-spacing:normal'; // theme button rule uppercased «Rimettila» (Simone #13: capital only at sentence start)
      b.addEventListener('click', () => {
        toast.style.display = 'none';
        restoreKit(receipt).catch(() => show(lang().failed, receipt)); // the button stays: retry
      }, { once: true });
      toast.append(b);
    }
    timer = setTimeout(() => { toast.style.display = 'none'; }, 5000);
  }
  function flush() {
    const r = pending.receipts.splice(0);
    if (r.length) show(lang().removed, r[r.length - 1]); // ponytail: one undo for the last removed kit
    else if (pending.extra) show(lang().extra);
    pending.extra = false;
  }
  const restoreKit = (receipt) => addKit(receipt);

  // ---------- triggers ----------
  document.addEventListener('ib:cart:updated', (e) => {
    const op = e.detail && e.detail.op;
    if (!inTx && op && op !== 'get' && op !== 'update_attributes') run();
  });
  const CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?([?#]|$)/;
  const CART_ADD = /\/cart\/add(\.js)?([?#]|$)/;
  const prevFetch = window.fetch;
  // Foreign add requests (ib-pdp.js on the Instant PDPs, product-form, apps) bypass window.ibCart: route them through its queue.
  // Only readable JSON {items} bodies are rewritten; opaque bodies are forwarded unchanged.
  window.fetch = function (input, init) {
    const url = String((input && input.url) || input);
    const method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    let res = null;
    if (method === 'POST' && CART_ADD.test(url)) {
      let body = null;
      try { if (!(input && input.url) && init && typeof init.body === 'string') body = JSON.parse(init.body); } catch (e) { body = null; }
      if (body && typeof body === 'object' && !Array.isArray(body)) {
        if (Array.isArray(body.items)) {
          res = viaKits(body.items, (items) => prevFetch.call(this, input, { ...init, body: JSON.stringify({ ...body, items }) }));
        } else {
          res = withAddQueue(() => prevFetch.apply(this, arguments));
        }
      } else res = withAddQueue(() => prevFetch.apply(this, arguments));
    }
    if (!res) res = prevFetch.apply(this, arguments);
    if (method === 'POST' && CART_WRITE.test(url)) res.then((r) => { if (r.ok) run(); }, () => {});
    return res;
  };
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') run(); });
  window.addEventListener('pageshow', (e) => { if (e.persisted) run(); });

  window.ibOffers = { planReconcile, planLineMutation: () => [], addKit, restoreKit, run, _plan: plan };
  if (window.ibCart) run();
})();
